/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React from 'react';
import withFooter from '@catalogo/service-americanas-footer';
import { getIn } from 'seamless-immutable';
import { FooterContent } from './components/footer-content';
import { Legal } from './components/legal';
import Social from './components/social';

export const Footer = ({ highlightList, config }) => {
  const accessibilityToken = getIn(config, ['footer', 'accessibilityToken'], '');
  const hotsite = getIn(config, ['footer', 'hotsite'], '');

  const loadHandTalkScript = () => {
    /* istanbul ignore next */
    if (document.getElementById('handTalk')) {
      return;
    }
    const script = document.createElement('script');
    script.id = 'handTalk';
    script.src = '//api.handtalk.me/plugin/latest/handtalk.min.js';
    document.getElementsByTagName('footer')[0].appendChild(script);

    /* istanbul ignore next */
    script.onload = () => {
      HandTalk();
    };
  };

  /* istanbul ignore next */
  const HandTalk = () => {
    const ht = new HT({
      token: accessibilityToken,
    });
  };

  return (
    <footer>
      <FooterContent highlightList={highlightList} />
      <Social loadHandTalkScript={loadHandTalkScript} hotsite={hotsite} />
      <Legal />
    </footer>
  );
};

export default withFooter(Footer);
